module.exports = __webpack_public_path__ + "img/itemDisplay1.550678bc.webp";